module.exports = __webpack_public_path__ + "static/media/8OLA20.2a2a91e6.jpg";